// i18n
import 'src/locales/i18n';

// ----------------------------------------------------------------------

import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { ErrorBoundary } from 'react-error-boundary';
import { QueryClient, QueryClientProvider } from 'react-query';
import {
  zhCN,
  ErrorFallback,
  App as AntdApp,
  useProtectImage,
  SnackbarProvider,
  AppConfigProvider,
} from 'design-system';

import Router from 'src/routes/sections';

import { AuthProvider } from 'src/auth/context/jwt';
import { recordTelemetryError } from 'src/services/telemetry';

import { ConfigProvider } from './config/config-provider';

dayjs.locale('zh-cn');
// ----------------------------------------------------------------------
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      staleTime: 0, // 禁用缓存
      cacheTime: 0, // 禁用缓存存储
      retry: 1,
    },
  },
});

export default function App() {
  useProtectImage();
  return (
    <ErrorBoundary
      fallbackRender={(errProps) => (
        <ErrorFallback {...errProps} showError={import.meta.env.VITE_NODE_ENV !== 'production'} />
      )}
      onError={(error, info) => {
        recordTelemetryError(error, {
          'exception.source': 'react-error-boundary',
          'react.component_stack': info.componentStack,
        });
        if (error?.toString()?.includes('Failed to fetch dynamically imported module')) {
          window.location.reload();
        }
        console.error(error, info);
      }}
    >
      <AppConfigProvider
        theme={{
          cssVar: true,
          components: {
            Layout: {
              bodyBg: '#F7F9FC',
            },
            Form: {
              labelColor: '#525866',
            },
          },
        }}
        locale={zhCN}
      >
        <AntdApp>
          <AuthProvider href={window.location.href}>
            <QueryClientProvider client={queryClient}>
              <SnackbarProvider>
                <ConfigProvider>
                  <Router />
                </ConfigProvider>
              </SnackbarProvider>
            </QueryClientProvider>
          </AuthProvider>
        </AntdApp>
      </AppConfigProvider>
    </ErrorBoundary>
  );
}
